import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/main.scss';
import { BrowserRouter } from 'react-router-dom';
import { logError } from '@shared/utils/errorLogging.ts';
import { Provider } from 'react-redux';
import { store } from '@shared/store.ts';
import { registerSW } from 'virtual:pwa-register';
import AnimationControlsProvider from '@shared/components/AnimationControlsProvider.tsx';

window.onerror = function (message, source, lineno, colno, error) {
  const errorData = {
    message,
    source,
    lineno,
    colno,
    stack: error?.stack,
  };

  logError(errorData);
};

registerSW({ immediate: true });

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <Provider store={store}>
      <React.StrictMode>
        <BrowserRouter>
          <AnimationControlsProvider>
            <App />
          </AnimationControlsProvider>
        </BrowserRouter>
      </React.StrictMode>
    </Provider>,
  );
}
